/*
 * CandyPeak Trust & Shipping Bar
 * Version 5.0.0
 *
 * FINAL:
 * - verwendet nur die vorhandene Proof-Leiste
 * - erzeugt niemals eine zweite Leiste
 * - entfernt alte/doppelte X-Leisten
 * - synchronisiert die Shopify-Headerhöhe genau einmal
 * - keine Hero-Margin-Messung, kein ResizeObserver, kein Springen
 */

(function () {
  'use strict';

  if (window.CandyPeakShippingBarV5Loaded) {
    return;
  }

  window.CandyPeakShippingBarV5Loaded = true;

  var SLIDE_DURATION = 3500;
  var currentSlideIndex = 0;
  var slideInterval = null;
  var activeBar = null;
  var waitObserver = null;
  var cleanupObserver = null;
  var cleanupFrame = null;

  function affectsShippingBar(mutation) {
    var selector = '#cp-proof-strip-v2,#cp-shippingbar,.cp-shippingbar-close,[data-cp-shippingbar-close],.section-header,.header-wrapper,.shopify-section-group-header-group';
    return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
      if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) return true;
      var text = node.nodeType === 3 ? node.nodeValue : node.textContent;
      if (!text || text.length > 12 || !isOnlyCloseMarks(text)) return false;
      var parent = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      return Boolean(parent && (parent.closest('.section-header,.header-wrapper,.shopify-section-group-header-group') ||
        (activeBar && (parent === activeBar.parentElement || parent === activeBar.parentElement?.parentElement))));
    });
  }

  function injectStyles() {
    var existingStyle = document.getElementById(
      'cp-shippingbar-styles'
    );

    if (existingStyle && existingStyle.parentNode) {
      existingStyle.parentNode.removeChild(existingStyle);
    }

    var style = document.createElement('style');

    style.id = 'cp-shippingbar-styles';
    style.setAttribute('data-version', '5');

    style.textContent = `
      /*
       * Alte Versionen dürfen nicht mehr sichtbar werden.
       */
      #cp-shippingbar,
      .cp-shippingbar-close,
      [data-cp-shippingbar-close],
      [data-cp-shippingbar-ghost="true"] {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
        min-height: 0 !important;
        max-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        overflow: hidden !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }

      /*
       * Wrapper, in denen vorher eine zusätzliche weiße
       * X-Zeile saß, auf die echte Bar reduzieren.
       */
      .cp-shippingbar-clean-host {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        background: transparent !important;
        overflow: visible !important;
      }

      .cp-shippingbar-clean-host
        > :not(#cp-proof-strip-v2) {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
        min-height: 0 !important;
        max-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        overflow: hidden !important;
      }

      #cp-proof-strip-v2.cp-shippingbar-root {
        width: 100% !important;
        height: 38px !important;
        min-height: 38px !important;
        max-height: 38px !important;

        position: relative !important;
        z-index: 9999 !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        margin: 0 !important;
        padding: 0 12px !important;
        border: 0 !important;
        box-sizing: border-box !important;

        background: linear-gradient(
          90deg,
          #f23b83 0%,
          #ee4f91 50%,
          #f23b83 100%
        ) !important;

        color: #ffffff !important;
        opacity: 1 !important;
        visibility: visible !important;
        transform: none !important;

        font-family:
          -apple-system,
          BlinkMacSystemFont,
          "SF Pro Text",
          "Helvetica Neue",
          Arial,
          sans-serif !important;

        font-size: 14px !important;
        font-weight: 500 !important;
        line-height: 1.2 !important;
        letter-spacing: -0.1px !important;
        text-align: center !important;

        box-shadow:
          0 1px 0 rgba(255, 255, 255, 0.12) inset,
          0 2px 8px rgba(0, 0, 0, 0.06) !important;

        overflow: hidden !important;
      }

      .cp-shippingbar-root .cp-shippingbar-slider {
        width: 100% !important;
        height: 100% !important;
        position: relative !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

        margin: 0 !important;
        padding: 0 !important;
        overflow: clip !important;
      }

      .cp-shippingbar-root .cp-shippingbar-slide {
        width: 100% !important;
        height: 100% !important;

        position: absolute !important;
        inset: 0 !important;

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 7px !important;

        margin: 0 !important;
        padding: 0 4px !important;
        box-sizing: border-box !important;

        color: #ffffff !important;
        white-space: nowrap !important;

        opacity: 0 !important;
        visibility: hidden !important;
        transform: translate3d(0, 100%, 0) !important;
      }

      .cp-shippingbar-root.is-ready
        .cp-shippingbar-slide {
        transition:
          transform 550ms cubic-bezier(0.22, 1, 0.36, 1),
          opacity 400ms ease,
          visibility 0ms linear 550ms !important;
      }

      .cp-shippingbar-root
        .cp-shippingbar-slide.is-active {
        opacity: 1 !important;
        visibility: visible !important;
        transform: translate3d(0, 0, 0) !important;
      }

      .cp-shippingbar-root.is-ready
        .cp-shippingbar-slide.is-active {
        transition:
          transform 550ms cubic-bezier(0.22, 1, 0.36, 1),
          opacity 400ms ease,
          visibility 0ms linear 0ms !important;
      }

      .cp-shippingbar-root
        .cp-shippingbar-slide.is-leaving {
        opacity: 0 !important;
        visibility: visible !important;
        transform: translate3d(0, -100%, 0) !important;
      }

      .cp-shippingbar-root.is-ready
        .cp-shippingbar-slide.is-leaving {
        transition:
          transform 550ms cubic-bezier(0.22, 1, 0.36, 1),
          opacity 400ms ease,
          visibility 0ms linear 550ms !important;
      }

      .cp-shippingbar-root .cp-shippingbar-icon {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 auto !important;
        font-size: 17px !important;
        line-height: 1 !important;
      }

      .cp-shippingbar-root .cp-shippingbar-text {
        display: inline-block !important;
        color: #ffffff !important;
        font-weight: 500 !important;
        line-height: 1.2 !important;
      }

      .cp-shippingbar-root strong {
        color: #ffffff !important;
        font-weight: 750 !important;
      }

      @media screen and (max-width: 989px) {
        body.template-index .section-header,
        body.template-index .header-wrapper,
        body.template-index .header {
          margin-bottom: 0 !important;
          padding-bottom: 0 !important;
        }

        body.template-index #MainContent,
        body.template-index
          #MainContent
          > .shopify-section:first-child,
        body.template-index
          #MainContent
          > .shopify-section:first-child
          > * {
          margin-top: 0 !important;
          padding-top: 0 !important;
        }
      }

      @media screen and (max-width: 749px) {
        #cp-proof-strip-v2.cp-shippingbar-root {
          height: 36px !important;
          min-height: 36px !important;
          max-height: 36px !important;
          padding: 0 8px !important;
          font-size: 13px !important;
          letter-spacing: -0.15px !important;
        }

        .cp-shippingbar-root .cp-shippingbar-slide {
          gap: 6px !important;
        }

        .cp-shippingbar-root .cp-shippingbar-icon {
          font-size: 16px !important;
        }
      }

      @media screen and (max-width: 390px) {
        #cp-proof-strip-v2.cp-shippingbar-root {
          font-size: 12px !important;
          letter-spacing: -0.2px !important;
        }

        .cp-shippingbar-root .cp-shippingbar-slide {
          gap: 5px !important;
        }

        .cp-shippingbar-root .cp-shippingbar-icon {
          font-size: 15px !important;
        }
      }

      @media screen and (max-width: 340px) {
        #cp-proof-strip-v2.cp-shippingbar-root {
          font-size: 11px !important;
        }

        .cp-shippingbar-root .cp-shippingbar-slide {
          gap: 4px !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .cp-shippingbar-root .cp-shippingbar-slide {
          transition: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function stopSlider() {
    if (slideInterval) {
      window.clearInterval(slideInterval);
      slideInterval = null;
    }
  }

  function showNextSlide() {
    if (
      !activeBar ||
      !document.documentElement.contains(activeBar)
    ) {
      stopSlider();
      return;
    }

    var slides = activeBar.querySelectorAll(
      '.cp-shippingbar-slide'
    );

    if (!slides || slides.length < 2) {
      return;
    }

    if (currentSlideIndex >= slides.length) {
      currentSlideIndex = 0;
    }

    var currentSlide = slides[currentSlideIndex];

    currentSlide.classList.remove('is-active');
    currentSlide.classList.add('is-leaving');

    currentSlideIndex =
      (currentSlideIndex + 1) % slides.length;

    var nextSlide = slides[currentSlideIndex];

    nextSlide.classList.remove('is-leaving');

    window.requestAnimationFrame(function () {
      nextSlide.classList.add('is-active');
    });

    window.setTimeout(function () {
      currentSlide.classList.remove('is-leaving');
    }, 600);
  }

  function startSlider() {
    stopSlider();

    if (!activeBar || document.hidden) {
      return;
    }

    slideInterval = window.setInterval(
      showNextSlide,
      SLIDE_DURATION
    );
  }

  function normalizeText(element) {
    return String(
      element && element.textContent
        ? element.textContent
        : ''
    )
      .replace(/\s+/g, '')
      .toLowerCase();
  }

  function isOnlyCloseMarks(value) {
    return /^(x|×){1,8}$/i.test(
      String(value || '').replace(/\s+/g, '')
    );
  }

  function removeDirectCloseTextNodes(element) {
    if (!element || !element.childNodes) {
      return;
    }

    Array.prototype.slice
      .call(element.childNodes)
      .forEach(function (node) {
        if (
          node.nodeType === Node.TEXT_NODE &&
          isOnlyCloseMarks(node.nodeValue)
        ) {
          element.removeChild(node);
        }
      });
  }

  function removeLegacyElements() {
    var selectors = [
      '#cp-shippingbar',
      '.cp-shippingbar-close',
      '[data-cp-shippingbar-close]'
    ].join(',');

    document
      .querySelectorAll(selectors)
      .forEach(function (element) {
        if (
          element &&
          element !== activeBar &&
          element.parentNode
        ) {
          element.parentNode.removeChild(element);
        }
      });
  }

  function chooseCanonicalBar() {
    var bars = Array.prototype.slice.call(
      document.querySelectorAll(
        '[id="cp-proof-strip-v2"]'
      )
    );

    if (!bars.length) {
      return null;
    }

    var header =
      document.querySelector('.section-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');

    var selected = bars[0];

    if (header && bars.length > 1) {
      var headerTop =
        header.getBoundingClientRect().top;

      var smallestDistance = Infinity;

      bars.forEach(function (candidate) {
        var rect =
          candidate.getBoundingClientRect();

        var distance =
          Math.abs(headerTop - rect.bottom);

        if (distance < smallestDistance) {
          smallestDistance = distance;
          selected = candidate;
        }
      });
    }

    bars.forEach(function (candidate) {
      if (
        candidate !== selected &&
        candidate.parentNode
      ) {
        candidate.setAttribute(
          'data-cp-shippingbar-ghost',
          'true'
        );

        candidate.parentNode.removeChild(candidate);
      }
    });

    return selected;
  }

  function cleanBarSurroundings(bar) {
    if (!bar) {
      return;
    }

    var parent = bar.parentElement;

    if (!parent) {
      return;
    }

    removeDirectCloseTextNodes(parent);

    Array.prototype.slice
      .call(parent.children)
      .forEach(function (sibling) {
        if (sibling === bar) {
          return;
        }

        var siblingText = normalizeText(sibling);

        var isOldClose =
          isOnlyCloseMarks(siblingText) ||
          sibling.classList.contains(
            'cp-shippingbar-close'
          ) ||
          sibling.hasAttribute(
            'data-cp-shippingbar-close'
          );

        if (
          isOldClose &&
          sibling.parentNode
        ) {
          sibling.parentNode.removeChild(sibling);
        }
      });

    /*
     * Nur einen kleinen eigenen Bar-Wrapper neutralisieren.
     * Große Shopify-/Header-Container bleiben unberührt.
     */
    var protectedParent =
      parent === document.body ||
      parent.id === 'MainContent' ||
      parent.classList.contains('section-header') ||
      parent.classList.contains('header-wrapper') ||
      parent.classList.contains(
        'shopify-section-group-header-group'
      ) ||
      parent.tagName === 'HEADER' ||
      parent.tagName === 'STICKY-HEADER';

    if (!protectedParent) {
      var meaningfulSibling =
        Array.prototype.slice
          .call(parent.children)
          .some(function (child) {
            if (child === bar) {
              return false;
            }

            var text = normalizeText(child);

            return (
              text.length > 0 &&
              !isOnlyCloseMarks(text)
            );
          });

      if (!meaningfulSibling) {
        parent.classList.add(
          'cp-shippingbar-clean-host'
        );
      }
    }

    if (parent.parentElement) {
      removeDirectCloseTextNodes(
        parent.parentElement
      );
    }
  }

  function removeVisibleXRowAboveBar(bar) {
    if (!bar) {
      return;
    }

    var barRect = bar.getBoundingClientRect();
    var viewportWidth =
      window.innerWidth ||
      document.documentElement.clientWidth;

    document
      .querySelectorAll(
        'div,section,aside,p,span,button'
      )
      .forEach(function (candidate) {
        if (
          candidate === bar ||
          candidate.contains(bar) ||
          bar.contains(candidate)
        ) {
          return;
        }

        if (
          !isOnlyCloseMarks(
            normalizeText(candidate)
          )
        ) {
          return;
        }

        var rect =
          candidate.getBoundingClientRect();

        var directlyAbove =
          rect.bottom <= barRect.top + 4 &&
          barRect.top - rect.bottom <= 20;

        var looksLikeGhostRow =
          rect.width >= viewportWidth * 0.65 &&
          rect.height > 0 &&
          rect.height <= 90;

        if (
          directlyAbove &&
          looksLikeGhostRow &&
          candidate.parentNode
        ) {
          candidate.parentNode.removeChild(
            candidate
          );
        }
      });
  }

  function buildBar(bar) {
    var ordersProof = bar.querySelector('[data-cp-orders-proof]');

    bar.classList.add('cp-shippingbar-root');

    bar.setAttribute(
      'role',
      'region'
    );

    bar.setAttribute(
      'aria-label',
      'CandyPeak Shopinformationen'
    );

    bar.setAttribute(
      'data-cp-shippingbar-ready',
      'true'
    );

    bar.innerHTML = `
      <div
        class="cp-shippingbar-slider"
        aria-live="polite"
      >
        <div
          class="cp-shippingbar-slide is-active"
          data-slide="shipping"
        >
          <span
            class="cp-shippingbar-icon"
            aria-hidden="true"
          >🚚</span>

          <span class="cp-shippingbar-text">
            <strong>2,99 € ab 50 € · kostenlos ab 70 €</strong>
          </span>
        </div>

        <div
          class="cp-shippingbar-slide"
          data-slide="orders"
        >
          <span
            class="cp-shippingbar-icon"
            aria-hidden="true"
          >📦</span>

          <span class="cp-shippingbar-text" data-cp-orders-target></span>
        </div>

        <div
          class="cp-shippingbar-slide"
          data-slide="reviews"
        >
          <span
            class="cp-shippingbar-icon"
            aria-hidden="true"
          >⭐</span>

          <span class="cp-shippingbar-text">
            <strong>4,3/5</strong>
            aus
            <strong>9.500+</strong>
            echten Bewertungen
          </span>
        </div>
      </div>
    `;

    var ordersTarget = bar.querySelector('[data-cp-orders-target]');
    if (ordersProof && ordersTarget) {
      var ordersCopy = ordersProof.cloneNode(true);
      ordersCopy.classList.add('cp-shippingbar-text');
      ordersTarget.replaceWith(ordersCopy);
    } else {
      bar.querySelector('[data-slide="orders"]').remove();
    }

    bar.addEventListener(
      'mouseenter',
      stopSlider
    );

    bar.addEventListener(
      'mouseleave',
      startSlider
    );

    bar.addEventListener(
      'focusin',
      stopSlider
    );

    bar.addEventListener(
      'focusout',
      startSlider
    );
  }

  function syncHeaderHeightOnce() {
    var headerSection =
      document.querySelector('.section-header');

    var stickyHeader =
      document.querySelector('sticky-header');

    if (!headerSection) {
      return;
    }

    /*
     * offsetHeight erzwingt eine synchrone Layoutberechnung.
     * Dadurch wird die neue 36/38-px-Bar vor dem nächsten
     * sichtbaren Frame korrekt in Shopify übernommen.
     */
    var finalHeight =
      Math.ceil(headerSection.offsetHeight);

    document.documentElement.style.setProperty(
      '--header-height',
      finalHeight + 'px'
    );

    if (
      stickyHeader &&
      typeof stickyHeader.setHeaderHeight ===
        'function'
    ) {
      stickyHeader.setHeaderHeight();
    }
  }

  function startCleanupObserver() {
    if (
      cleanupObserver ||
      !('MutationObserver' in window)
    ) {
      return;
    }

    cleanupObserver =
      new MutationObserver(function (mutations) {
        if (cleanupFrame !== null || !mutations.some(affectsShippingBar)) return;
        cleanupFrame = window.requestAnimationFrame(function () {
          cleanupFrame = null;
          removeLegacyElements();
          if (activeBar?.isConnected) {
            cleanBarSurroundings(activeBar);
            removeVisibleXRowAboveBar(activeBar);
          }
        });
      });

    cleanupObserver.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function waitForBar() {
    if (
      waitObserver ||
      !('MutationObserver' in window)
    ) {
      return;
    }

    waitObserver =
      new MutationObserver(function (mutations) {
        if (mutations.some(function (mutation) {
          return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
            return node.nodeType === 1 && (node.matches('#cp-proof-strip-v2') || node.querySelector('#cp-proof-strip-v2'));
          });
        })) {
          waitObserver.disconnect();
          waitObserver = null;
          initialize();
        }
      });

    waitObserver.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }

  function initialize() {
    injectStyles();
    stopSlider();
    removeLegacyElements();

    var bar = chooseCanonicalBar();

    if (!bar) {
      waitForBar();
      return;
    }

    if (waitObserver) {
      waitObserver.disconnect();
      waitObserver = null;
    }

    activeBar = bar;
    currentSlideIndex = 0;

    if (
      bar.getAttribute(
        'data-cp-shippingbar-ready'
      ) !== 'true'
    ) {
      buildBar(bar);
    }

    cleanBarSurroundings(bar);
    removeVisibleXRowAboveBar(bar);

    /*
     * Nur ein einziger synchroner Header-Abgleich.
     * Keine Hero-Verschiebung und kein Observer-Loop.
     */
    syncHeaderHeightOnce();

    window.requestAnimationFrame(function () {
      removeLegacyElements();
      cleanBarSurroundings(bar);
      removeVisibleXRowAboveBar(bar);
      bar.classList.add('is-ready');
    });

    startCleanupObserver();
    startSlider();
  }

  initialize();

  document.addEventListener(
    'visibilitychange',
    function () {
      if (document.hidden) {
        stopSlider();
      } else {
        startSlider();
      }
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      window.setTimeout(initialize, 50);
    }
  );

  window.addEventListener(
    'load',
    function () {
      removeLegacyElements();

      if (activeBar) {
        cleanBarSurroundings(activeBar);
        removeVisibleXRowAboveBar(activeBar);
      }
    },
    { once: true }
  );
})();

